import {
  Grid,
  GridColumn,
  useSnackbar,
} from "@walmart-web/livingdesign-components";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiDataTable from "../../components/Table/MuiDataTable/MuiDataTable";
import JobStatusListStyle from "./JobStatusList.styles";
import { useHistory } from 'react-router-dom';
import { formSearchQuery, getErrorMessage } from "../../helpers/utils";
import { setJobStatusData } from "../../store/actions/jobStatusActions";
import { JOB_SERVICE } from "../../constants/baseURLs";
import MuiDateItem from "../../components/Table/MuiDataTable/MuiDateItem/MuiDateItem";
import { getService } from "../../axios/axios";
import { displayLocalDate } from "../../helpers/utcUtils";
import { JOB_COMMANDS, JOB_TITLE_FILTER_OPTIONS, PROCESS_STATUS_ADVISORY } from "../../constants/constants";
import { MOMENT_DATE_FORMAT } from "../../constants/dateFormats";
import { TableCellDisplay, renderStatus } from "../../helpers/commonUtils";
import { Operations } from "../../axios/operations";
import { ROWS_PER_PAGE_OPTIONS_DEFAULT, ROWS_PER_PAGE_PEOPLE } from "../../constants/tableConfigs";

const JobStatusList = (props) => {
  const classes = JobStatusListStyle();
  const userDetails = useSelector(state => state?.user?.userDetail?.attributes);
  const [filterQuery, setFilterQuery] = useState("");
  const [sortQuery, setSortQuery] = useState(`&order=jobNumber desc`);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE_PEOPLE);
  const [page, setPage] = useState(0);

  const renderSubmittedTs=(value, tableMeta, updateValue) => {
    return <MuiDateItem value={displayLocalDate(value,MOMENT_DATE_FORMAT ,"")} />;
  }

  const defaultQuery = `${formSearchQuery(
    "submittedById",
    Operations.EQ,
    userDetails?.userUniqueId,
    'id'
    
  )} and ${formSearchQuery(
    "isActive",
    Operations.EQ,
    true,
    'boolean',
  )}`;

  const COLUMNS = [
    {
      name: "id",
      label: "id",
      colKey: "id",
      options: {
        display: false,
      }
    },
    {
      name: "jobNumber",
      label: "Task #",
      colKey: "jobNumber",
      options: {
        customBodyRender: (value, tableMeta) => TableCellDisplay(`Mui-job-status-row-${tableMeta?.rowIndex}`, value),
      }
    },
    {
      name: "submittedTs",
      label: "Created on",
      colKey: "submittedTs",
      options: {
        setCellProps: () => ({ style: { maxWidth: "150px", minWidth: "150px" } }),
        setCellHeaderProps: () => ({ style: { maxWidth: "150px", minWidth: "150px" } }),
        customBodyRender: renderSubmittedTs,
      },
    },
		{
      name: "title",
      label: "Task",
      colKey: "title",
      options: {
        setCellProps: () => ({ style: { maxWidth: "150px", minWidth: "150px" } }),
        setCellHeaderProps: () => ({ style: { maxWidth: "150px", minWidth: "150px" } }),
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-title-${tableMeta?.rowIndex}`, value),
      }
    },
		{
      name: "description",
      label: "Details",
      colKey: "description",
      options: {
        setCellProps: () => ({ style: { maxWidth: "200px", minWidth: "200px" } }),
        setCellHeaderProps: () => ({ style: {  maxWidth: "200px", minWidth: "200px" } }),
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-description-${tableMeta?.rowIndex}`, value)
      }
    },
    {
      name: "taskCount",
      label: "# of Invoices/Lines",
      colKey: "taskCount",
      options: {
        setCellProps: () => ({ style: { paddingLeft: "20%" } }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
        customBodyRender: (value, tableMeta) => <div style={{paddingLeft:"30%"}}><p id={`table-row-description-${tableMeta?.rowIndex}`}>{value}</p></div>

      }
    },
    {
      name: "status",
      label: "Status",
      colKey: "status",
      options: {
        setCellProps: () => ({ style: { maxWidth: "100px", minWidth: "100px" } }),
        setCellHeaderProps: () => ({ style: { maxWidth: "100px", minWidth: "100px" } }),
        customBodyRender: renderStatus,
      }
    },
    {
      name: "submittedByFirstName",
      label: "submittedByFirstName",
      colKey: "submittedByFirstName",
      options: {
        display:false
      },
    },
    {
      name: "submittedByLastName",
      label: "submittedByLastName",
      colKey: "submittedByLastName",
      options: {
        display:false
      },
    },
    {
      name: "fileName",
      label: "File Name",
      colKey: "fileName",
      options: {
        display: true,
        customBodyRender: (value, tableMeta) => TableCellDisplay(`table-row-description-${tableMeta?.rowIndex}`, value ?? "-")
      },
    },
    {
      name: "jobTasks.taskIdentifier",
      label: "taskid",
      colKey: "jobTasks.taskIdentifier",
      options: {
        display: false
      },
    },
  ];

  const FILTER_CONFIGS = [
    
    {
      colKey: "jobTasks.taskIdentifier",
      type: "textField",
      label: "Find an Invoice No.",
      defaultOpen: true,
      displayLabel: true,
      fullWidth: "100"
    },
    {
      colKey: "title",
      type: "dropdownAutocomplete",
      label: "Task to",
      defaultOpen: true,
      displayLabel: true,
      options: JOB_TITLE_FILTER_OPTIONS,
      fullWidth: "100"
    },
    {
      colKey: "description",
      type: "textField",
      label: "Task detail",
      defaultOpen: true,
      displayLabel: true,
      fullWidth: "100"
    },
    {
      colKey: "status",
      type: "dropdownAutocomplete",
      label: "Status",
      defaultOpen: true,
      options: ["Error","In Progress","Partial Success","Success"],
    },
    {
      colKey: "submittedTs",
      type: "rangePicker",
      label: "Task created on",
      defaultOpen: true,
      section: "right",
      maxDate: new Date().toISOString().split('T')[0],
      displayLabel: true,
    },
   
  ];

  const handleServerSideFilter = (query) => {
    setFilterQuery(`and ${query}`);
  };

  const handleServerSidePagination = ({ rowsPerPage, page }) => {
    setRowsPerPage(rowsPerPage);
    setPage(page);
  };

  const [jobStatusColumns, setJobStatusColumns] = useState(COLUMNS);
  const { jobStatusData } = useSelector(state => state?.processStatus);
  const history = useHistory()
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { addSnack } = useSnackbar();

  useEffect(() => {
    getJobStatusData();
    if (props?.fromLink) {
      history.push("/financial", {currentFinancialTab: 3} )
    }
  }, [filterQuery, sortQuery, rowsPerPage, page]);

  /*
* Function to get list of all the Process Status for the Logged In User ID
*/
  const getJobStatusData = () => {
    setLoading(true);
    const paginationQuery = formPaginationQuery(rowsPerPage, page);
    getService(JOB_SERVICE,  `/search/jobs/v1/?filter=${defaultQuery} ${filterQuery} ${sortQuery} ${paginationQuery}`)
    .then((res) => {
      const data = res?.data;
      const type = JOB_COMMANDS?.[res?.data?.command]?.type;
      data?.jobTasks?.forEach(job => {
        job["bulkOperationType"] = type;
      });
      dispatch(setJobStatusData(res?.data))
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
      addSnack({
        message: getErrorMessage(error)
      });
    });
  }

  const formPaginationQuery = (rowsPerPage, pageNumber) => (`&offset=${rowsPerPage * pageNumber}&limit=${rowsPerPage}`);

  const handleServerSideSort = ({ name, direction }) => {
    const sortQuery = `&order=${name} ${direction}`;
    setSortQuery(sortQuery);
  };

  const jobStatusCustomOptions = {
    totalCount: jobStatusData?.count,
    responsive: "standard",
    filterConfigs: FILTER_CONFIGS,
    serverSide: true,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS_DEFAULT,
    page: page,
    onServerSidePagination: handleServerSidePagination,
    onServerSideFilter: handleServerSideFilter,
    onServerSideSort: handleServerSideSort,
  };

  /*
  *On Click of Row Element of Job-Status List
  */
  const handleRowClick = (rowData, rowMeta) => {
    history.push(`/processStatus/${jobStatusData?.jobRequestDtoList[rowMeta?.dataIndex]?.id}`)
  }

  /*
  *On Click of Refresh Button
  */
  const refreshJobStatusData = () => {
    getJobStatusData()
  }

  return (
      <Grid hasGutter={true}>
        <GridColumn>
          <MuiDataTable
            data={jobStatusData?.jobRequestDtoList}
            columns={jobStatusColumns}
            setTableColumns={setJobStatusColumns}
            disableExport={true}
            disableSearch={true}
            hideAddNewButton={true}
            customOptions={jobStatusCustomOptions}
            onRowClick={handleRowClick}
            showCustomButton={ true }
            customButtonText={"Refresh"}
            customButtonCallback={refreshJobStatusData}
            loading={loading}
          />
        </GridColumn>
        <GridColumn className={classes.footer}>
          {PROCESS_STATUS_ADVISORY}
        </GridColumn>
      </Grid>
    )
};

export default JobStatusList;